import InputGroup from "components/_other/form/InputGroup";

const CheckboxInput = ({
   label,
   error = '',
   inputProps = {},
 }) => {
  const {
    id,
    name,
    checked = false,
    value = '',
    scale = false,
    inputClassName = '',
    groupClassName = '',
    ...restInputProps
  } = inputProps;
  const inputId = (id || name) + '-' + value;
  return (
    <InputGroup groupClassName={`customImgCheckbox ${groupClassName} ${
      scale ? 'scaledCheckbox' : ''
    } ${inputClassName}`}
    >
      <label className="inline-flex">
        <input
          id={inputId}
          type="checkbox"
          checked={checked}
          name={name}
          value={value}
          className={'me-2'}
          {...restInputProps}
        />
        <span className={`ml-2 label`}>
          {label}
        </span>
      </label>
      {error ? <span className='text-sm flex text-danger'>{error}</span> : null}
    </InputGroup>
  );
};

export default CheckboxInput;
